const messages = {
  DOWNLOAD_NOW: 'on the Instarem app. Download now for iOS or Android.',
  FLAG_LABEL: 'Cheaper on the app',
  BETTER_RATES: 'Get better rates',
  SHOW_ME_HOW: 'Show me how',
  DOWNLOAD_APP: 'Download app',
  PROCEED_ON_WEB: 'Proceed on web',
  GET_APP: 'Great, I’ll get the app',
  MOBILE_APP_DOWNLOAD:
    'This transfer is cheaper on the Instarem app! Download the app from App Store or Google Play.',
  SCAR_QR_CODE:
    "'This transfer is cheaper on the Instarem app! Scan this QR code with your phone to download the app from App Store or Google Play.'",
  downloadBtn_label: 'Download app',
  downloadBtn_title: 'APP_MIGRATION_DOWNLOAD_APP_BUTTON',
  downloadNow: 'Download now for iOS or Android.',
  extras: {
    mobile_app_download: 'Download the app from App Store or Google Play.'
  },
  flagLabel: 'Save with the app',
  getBeeterRatesLabel: 'Get better rates',
  getBeeterRatesWithFessLabel: 'Save {value}  {currency} with the Instarem app',
  getTheAppBtn_label: 'Great, I’ll get the app',
  getTheAppBtn_title: 'APP_MIGRATION_GET_THE_APP',
  heading_heading: 'Save 1.25 AUD with the Instarem app\nIn-app rate is 1 AUD = 0.98 USD 0.99 USD',
  heading_subHeading: 'Save when sending\nwith the Instarem app',
  heading_title: 'APP_MIGRATION_CURRENCY_CONVERTOR_HEADING',
  modalContent_heading:
    'Scan this QR code with your phone to download the app from App Store or Google Play.',
  modalContent_subHeading: 'Get better exchange rates on our app',
  modalContent_title: 'APPMIGRATION_MODAL_CONTENT',
  modalHeading_heading: 'Save when sending\n',
  modalHeading_subHeading: 'with the Instarem app',
  modalHeading_title: 'APP_MIGRATION_MODAL_HEADING',
  modalSubmitButton_label: 'Great, thanks!',
  modalSubmitButton_title: 'APPMIGRATION_MODAL_SUBMIT_BUTTON',
  proceedButton_label: 'Proceed',
  proceedButton_title: 'APP_MIGRATION_PROCEED_BUTTON',
  proceedOnWebBtn_label: 'Proceed on web',
  proceedOnWebBtn_title: 'APP_MIGRATION_PROCEED_ON_WEB',
  showMeHowButton_label: ' Show me how',
  showMeHowButton_title: 'APP_MIGRATION_SHOW_ME_HOW',
  thanksButton_label: 'Great, tahnks!',
  thanksButton_title: 'APP_MIGRATION_THANKS_BUTTON',
  title: 'APP_MIGRATION'
};

export default messages;
